import React, { useState, useEffect, Fragment } from "react";
import Container from 'react-bootstrap/Container';
import axios from 'axios';
import AuthService from '../../Auth/AuthService.js';
import { settings } from './../../Helpers/Settings.js';
import { ToastContainer, toast } from "react-toastify";
import Swal from 'sweetalert2'
import PageTitle from "../../Components/PageTitle.js";
import "react-toastify/dist/ReactToastify.css";
import JoditEditor from 'jodit-react';
import { joditToolbar } from './../../Helpers/JoditToolbar.js';
import Select from 'react-select'
import { decodeToken, isExpired } from "react-jwt";

const MesajYaz = () => {
    useEffect(() => {
        getAcilisData();
    }, []);

    const [isTokenExpired, setIsTokenExpired] = useState(false);
    const [yetkiGor, setYetkiGor] = useState(null);

    const [kisiler, setKisiler] = useState([]);
    const [selectedKisiler, setSelectedKisiler] = useState([]);
    const [konu, setKonu] = useState('');
    const [icerik, setIcerik] = useState('');
    const [yanitlananKisiIndex, setYanitlananKisiIndex] = useState(-1);

    const tokenYenile = async () => {
        if (isExpired(localStorage.getItem('ATGroupToken')) === true) {
            setIsTokenExpired(true);
            return false;
        } else {
            const mail = decodeToken(localStorage.getItem('ATGroupToken'))["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"];
            await AuthService.login(mail, localStorage.getItem('ATGroupToken'));
            return true;
        }
    }

    const getAcilisData = async () => {
        if (await tokenYenile() === false) {
            return;
        }
        
        let tempYetkiGor = await AuthService.getYetkiKontrolByYetki("Ayarlar - Kullanıcılar - Mesajlaşma");

        setYetkiGor(tempYetkiGor);

        if (tempYetkiGor === true) {
            const kisilerTemp = (await axios.get(settings.ApiUrl + 'Kullanici/GetKullaniciOrMesajGrubuList', { headers: AuthService.getHeaders() })).data.value;

            setKisiler(kisilerTemp);

            const paramsTemp = window.location.pathname.toLowerCase().replace("/mesaj/mesajyaz/", "");

            if (paramsTemp) {
                if (paramsTemp !== "") {
                    const yanitlaIlet = paramsTemp.split("/")[0];
                    const gelenGiden = paramsTemp.split("/")[1];
                    const id = paramsTemp.split("/")[2];

                    if (yanitlaIlet && gelenGiden && id) {
                        const result = await axios.get(settings.ApiUrl + 'Mesaj/GetMesaj/' + gelenGiden + "/" + id , { headers: AuthService.getHeaders() });

                        if (result) {
                            if (result.data.success === true) {
                                if (yanitlaIlet === "1") {
                                    let yanitlananKisiIndex = -1;
                                    let i = -1;

                                    kisilerTemp.forEach(element => {
                                        i++;

                                        if (result.data.value.gonderenKisiId === element.value) {
                                            yanitlananKisiIndex = i;
                                        }
                                    });

                                    setYanitlananKisiIndex(yanitlananKisiIndex);
                                }
                                
                                setKonu((yanitlaIlet === "1" ? "Yanıt: " : (yanitlaIlet === "2" ? "İlet: " : "")) + result.data.value.konu);
                                setIcerik("<br/><br/><hr/>" + result.data.value.icerik)
                            }
                        }
                    }
                }
            }
        }
    }

    const Kaydet = async () => {
        if (await tokenYenile() === false) {
            return;
        }

        if (selectedKisiler.length === 0 || konu === "" || icerik === "") {
            Swal.fire({ title: "Hata", text: "Lütfen tüm alanları doldurunuz", icon: "error" });
        } else {
            try {
                const data = JSON.stringify({
                    "mesaj": {
                        "konu": konu,
                        "icerik": icerik
                    },
                    "mesajGonderilenKisiler": selectedKisiler,
                });

                const result = await axios.post(settings.ApiUrl + 'Mesaj/InsertMesaj/', data, { headers: AuthService.getHeaders() });

                if (result) {
                    setSelectedKisiler([]);
                    setKonu("");
                    setIcerik("");
                    setYanitlananKisiIndex(-1);

                    toast.success("Mesaj gönderildi");

                    document.getElementById('btnBildirimYenile').click();
                }
            } catch (error) {
                toast.error(error);
            }
        }
    }

    return (

        <Fragment>

            <Container>
                <ToastContainer position="bottom-right">
                </ToastContainer>
            </Container>

            <PageTitle></PageTitle>

            {
                isTokenExpired === true ?
                    <div className="alert alert-danger mb-1">
                        <button className="btn btn-link btn-sm" style={{color:"#58151c"}} onClick={() => AuthService.logout()}>Uzun süredir işlem yapmadığınız için oturumunuz sonlandırıldı. Lütfen tekrar giriş yapınız.</button>
                    </div>
                    :
                    yetkiGor !== null ?
                        yetkiGor === false ?
                            <div className="alert alert-danger">
                                Bu sayfaya erişim yetkiniz bulunmamaktadır
                            </div>
                            :
                            <div className="row">
                                <div className="col-md-12 mb-3">
                                    <div className="input-group input-group-sm">
                                        <label className="input-group-text" id="lblKisiler" style={{ width: "120px" }}>Kime<span style={{ color: "red", paddingLeft: "4px" }}>*</span></label>
                                        <Select aria-describedby="lblKisiler" options={kisiler} defaultValue={kisiler[yanitlananKisiIndex]} onChange={(e) => setSelectedKisiler(e)} isMulti className="form-control form-control-sm reactSelect" />
                                    </div>
                                </div>
                                <div className="col-md-12 mb-3">
                                    <div className="input-group input-group-sm">
                                        <label className="input-group-text" id="lblKonu" style={{ width: "120px" }}>Konu<span style={{ color: "red", paddingLeft: "4px" }}>*</span></label>
                                        <input aria-describedby="lblKonu" type="text" className="form-control form-control-sm" value={konu} onChange={(e) => setKonu(e.target.value)}></input>
                                    </div>
                                </div>
                                <div className="col-md-12 mb-3">
                                    <JoditEditor config={joditToolbar} value={icerik} onChange={(e) => setIcerik(e)}></JoditEditor>
                                </div>
                                <div className="col-md-12">
                                    <button className="btn btn-success w-100" onClick={Kaydet}><i className="bi bi-check-lg mr-2"></i> Mesajı Gönder</button>
                                </div>
                            </div>
                        :
                        ""
            }

        </Fragment>
    );
};

export default MesajYaz;